export function RecoveryCodeList({ codes }) {
  if (!codes?.length) {
    return null;
  }

  return (
    <ul className="recovery-codes">
      {codes.map((code) => (
        <li key={code}>{code}</li>
      ))}
    </ul>
  );
}
